var React = require('react');

function CaseCardBottomLeftDecorator (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.324989 0.774902C13.2263 43.6517 62.9237 68.8642 86.3223 75.5044H8.03487C3.603 75.5044 0.0156708 71.9014 0.0349426 67.4696L0.324989 0.774902Z","fill":"#18181B"}));
}

CaseCardBottomLeftDecorator.defaultProps = {"width":"87","height":"76","viewBox":"0 0 87 76","fill":"none"};

module.exports = CaseCardBottomLeftDecorator;

CaseCardBottomLeftDecorator.default = CaseCardBottomLeftDecorator;
